import gsap from 'gsap';
import appStore from '../utils/state';

export default class MainGlobalOverlay extends HTMLElement {
  private showTl: gsap.core.Timeline | null = null;
  private hideTl: gsap.core.Timeline | null = null;

  private isVisible: boolean = false;

  private unsubscribeFromMarketModalState: (() => void) | null = null;

  private onClickBound = this.onClick.bind(this);
  private onMarketModalToggleBound = this.onMarketModalToggle.bind(this);

  connectedCallback(): void {
    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    this.addEventListener('click', this.onClickBound);
  }

  removeEventListeners(): void {
    this.removeEventListener('click', this.onClickBound);
  }

  subscribe(): void {
    this.unsubscribeFromMarketModalState = appStore.subscribeKey('isMarketModalOpen', this.onMarketModalToggleBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromMarketModalState) {
      this.unsubscribeFromMarketModalState();
      this.unsubscribeFromMarketModalState = null;
    }
  }

  onClick(): void {
    appStore.actions.closeMarketModal();
  }

  onMarketModalToggle(): void {
    const isMarketModalOpen = appStore.getState().isMarketModalOpen;

    if (isMarketModalOpen) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(): void {
    if (this.hideTl) {
      this.hideTl.kill();
    }
    if (this.showTl) {
      this.showTl.kill();
    }

    this.showTl = gsap.timeline();
    if (this.isVisible == false) {
      this.showTl.set([window.document.body], { overflow: 'hidden' }, 0);
      this.showTl.fromTo(this, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, ease: 'power2.out' }, 0);
    }

    this.isVisible = true;
  }

  hide(): void {
    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }

    this.hideTl = gsap.timeline();
    this.hideTl.set([window.document.body], { clearProps: 'overflow' }, 0);
    this.hideTl.to(this, { autoAlpha: 0, duration: 0.2, ease: 'power2.out' }, 0);

    this.isVisible = false;
  }

  disconnectedCallback(): void {
    this.unsubscribe();
    this.removeEventListeners();

    if (this.showTl) {
      this.showTl.kill();
    }
    if (this.hideTl) {
      this.hideTl.kill();
    }
  }
}

customElements.define('main-global-overlay', MainGlobalOverlay);
